var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBpm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108.792,
    height: 34.296,
    viewBox: "0 0 108.792 34.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    width: 108.792,
    height: 34.296,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.368,51.211a13.046,13.046,0,0,1,2.729.264,5.9,5.9,0,0,1,2.113.866,4.029,4.029,0,0,1,1.365,1.6,5.621,5.621,0,0,1,.484,2.465,4.591,4.591,0,0,1-.719,2.641,5.226,5.226,0,0,1-2.128,1.731A5.04,5.04,0,0,1,196.1,62.73a6.407,6.407,0,0,1,.337,6.1,5.347,5.347,0,0,1-1.658,1.893,7.339,7.339,0,0,1-2.377,1.086,10.711,10.711,0,0,1-2.744.352H179.507V51.211Zm-.587,8.481a3.31,3.31,0,0,0,2.025-.587A2.217,2.217,0,0,0,191.6,57.2a2.436,2.436,0,0,0-.264-1.2,1.955,1.955,0,0,0-.7-.734,2.971,2.971,0,0,0-1.012-.367,6.733,6.733,0,0,0-1.189-.1h-4.314v4.9Zm.264,8.892a6.148,6.148,0,0,0,1.291-.132,3.17,3.17,0,0,0,1.086-.44,2.224,2.224,0,0,0,.748-.836,2.882,2.882,0,0,0,.279-1.35,2.711,2.711,0,0,0-.91-2.3,3.885,3.885,0,0,0-2.406-.69h-5.018v5.752Z",
    transform: "translate(-132.881 -37.909)",
    fill: "#f48678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5,51.211a8.735,8.735,0,0,1,3.346.572,6.267,6.267,0,0,1,2.245,1.511,5.816,5.816,0,0,1,1.262,2.142,8,8,0,0,1,0,4.974,5.787,5.787,0,0,1-1.262,2.157,6.26,6.26,0,0,1-2.245,1.511,8.73,8.73,0,0,1-3.346.572h-4.842V68.33a3.834,3.834,0,0,1-3.834,3.834h-.773V51.211Zm-1.262,9.861a9.628,9.628,0,0,0,1.526-.117,3.545,3.545,0,0,0,1.291-.455,2.476,2.476,0,0,0,.895-.954,4.027,4.027,0,0,0,0-3.228,2.479,2.479,0,0,0-.895-.954,3.559,3.559,0,0,0-1.291-.455,9.689,9.689,0,0,0-1.526-.117h-3.58v6.28Z",
    transform: "translate(-191.761 -37.909)",
    fill: "#f48678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.634,51.211a6.95,6.95,0,0,1,6.633,4.978l3.208,9.431h.059l2.683-9.325a7.33,7.33,0,0,1,6.978-5.085h1.144V72.165h-.89a3.424,3.424,0,0,1-3.424-3.424V57.315h-.059l-4.237,13.169a2.5,2.5,0,0,1-4.717.007l-4.233-13.029h-.058V68.718a3.447,3.447,0,0,1-3.447,3.447h-.868V51.211Z",
    transform: "translate(-247.546 -37.909)",
    fill: "#f48678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.344,23.5a9.092,9.092,0,0,0-9.119-9.063l-4.308.013V20.39a6.936,6.936,0,0,1-6.928,6.928,7.057,7.057,0,0,1-7.049-7.049,6.936,6.936,0,0,1,6.928-6.928h5.99l-.013-4.278A9.092,9.092,0,0,0,10.726,0L0,.033.044,14.511H.034l.027,8.916A10.9,10.9,0,0,0,11,34.3l23.382-.072Z",
    transform: "translate(0.001 0)",
    fill: "#f48678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.07,64.471a4.886,4.886,0,0,0,4.88,4.88,4.765,4.765,0,0,0,4.759-4.759v-4.88h-4.88a4.765,4.765,0,0,0-4.759,4.759",
    transform: "translate(-25.961 -44.202)",
    fill: "#f48678"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpm);
export default __webpack_public_path__ + "static/media/bpm.c3da7b568c93a3e40176a5329ffe8bf0.svg";
export { ForwardRef as ReactComponent };